var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("基本配置")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("系统文件")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "manage" }, [
      _c(
        "div",
        {
          staticClass: "header",
          staticStyle: {
            display: "flex",
            "align-items": "center",
            "justify-content": "space-between",
          },
        },
        [
          _c("p", [_vm._v("列表数据")]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "medium" },
              on: { click: _vm.toAdd },
            },
            [_vm._v("新增")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "vxe-table",
            { attrs: { align: "center", "keep-source": "", data: _vm.list } },
            [
              _c("vxe-table-column", {
                attrs: { title: "ID", field: "id", width: "55" },
              }),
              _c("vxe-table-column", {
                attrs: { title: "标题", field: "title" },
              }),
              _c("vxe-table-column", {
                attrs: { title: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.toAdd(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("查看/编辑")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.copyFn(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("复制链接")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }